import { Link } from "react-router";
import { LuArrowLeft } from "react-icons/lu";
import "./BackLink.scss";

/**
 * Back navigation link for Plan Manager detail headers.
 *
 * @param {object} props
 * @param {string} props.to - Router destination.
 * @param {string} props.label - Visible link text.
 * @param {string} props.ariaLabel - Accessible label for the link.
 * @param {(event: import('react').MouseEvent<HTMLAnchorElement>) => void} [props.onClick]
 * @returns {import('react').JSX.Element}
 */
const BackLink = ({ to, label, ariaLabel, onClick }) => (
    <Link
        to={to}
        className="plan-manager-back-link"
        aria-label={ariaLabel}
        onClick={onClick}
    >
        <LuArrowLeft aria-hidden size={18} />
        <span>{label}</span>
    </Link>
);

export default BackLink;
